// extracted by mini-css-extract-plugin
module.exports = {"button":"SubmitButton_button__Kx3xt","tickMark":"SubmitButton_tickMark__9iupx"};